export const buttonTheme = {
  defaultProps: {
    colorScheme: 'blue',
  },
}
